import rmskincareAPI from '../utils/rmskincareAPI';

const employeeApi = {

  getEmployeeList: async (type) => {
    let result
    if(type == undefined){
      result = await rmskincareAPI.get(`management/employee/available`)
    }else{
      result = await rmskincareAPI.get(`management/employee/available?type=${type}`)
    }
    return result.data.data;
  },

  getSalesEmployeeList: async (type,flag) => {
    let result
    if(flag == 1){
      result = await rmskincareAPI.get(`management/employee/available?salesType=${type}&flag=1`)
    }else{
      result = await rmskincareAPI.get(`management/employee/available?salesType=${type}`)
    }
    return result.data.data;
  },

  getEmployeeById: async (id) => {
    let result = await rmskincareAPI.get(`management/employee/${id}`);
    return result.data.data;
  },

  getPageEmployee: async (page) => {
    const result = await rmskincareAPI.get(
      `/management/employee/${page}`
    )
    return result.data.data
  },
  addEmployee: async (requestBody) => {
    const result = await rmskincareAPI.post(
      `/management/employee/`,requestBody
    )
    return result.data.data
  },

  updateEmployee: async (id,requestBody) => {
    const result = await rmskincareAPI.put(
      `/management/employee/${id}`,requestBody
  )
   return result.data.data
  },

}

export default employeeApi
